module.exports = __webpack_public_path__ + "static/media/DocumentExpired.3ae23029.svg";